<template>
    <div class="integration-content">
      <div class="integration-content-card">
        <header>
          <img src="@/assets/integrations/figma.svg" alt="Figma" />
          <div class="header-text">
            <h4>Figma</h4>
            <h5>User Interface</h5>
          </div>
        </header>
        <div class="integration-content-card-body">
          <p class="description">
            FIGMA is a cloud-based UI design and prototyping tool. With FIGMA integration, it is possible to:
          </p>

          <ul>
            <li>Import a copy of UI designs into the metastory AI screen board</li>
            <li>Update screens and placeholders with Figma designs</li>
          </ul>
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  export default {
    name: 'FigmaDescription',
  };
  </script>
